import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import { formatDate } from "../../../components/common/Converter";
// import { JobGenerateCSV, JOBPrintPDF } from "./PrintJobPosting/JOBPrintPDF";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import CommitteeListPresenter from "./CommitteeListPresenter";

class CommitteeListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CommitteeListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      description: "",
      sendToAll: false,
      offices: [],
      count: 0,
      limit: 10,
      current: 1,
      positionTitle: [],
      // fields: {}
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const positionTitle = await findObjectUseCase().execute("position_titles");
    this.setState({ positionTitle });
  }

  // delete function
  async handleClosed(id) {
    const alljobs = await findObjectUseCase().execute("job_postings");
    const job = alljobs.find((item) => item.id === id);
    const { closed, dateClosed, ...exclude } = job;
    const closedData = {
      dateClosed: formatDate(new Date()),
      closed: "true",
      ...exclude,
    };
    console.log("OBJECT: ", closedData);
    await upsertUseCase().execute("job_postings", closedData);
    this.refetchData();
  }

  async handleReOpen(object) {
    const alljobs = await findObjectUseCase().execute("job_postings");
    const job = alljobs.find((item) => item.id === object.id);
    const { closed, dateClosed, ...exclude } = job;
    const openData = {
      dateClosed: "",
      closed: "false",
      ...exclude,
    };
    console.log("OBJECT: ", openData);
    await upsertUseCase().execute("job_postings", openData);
    this.refetchData();
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  //   handlePrintPDF(object) {
  //     // console.log("OBJECT: ", object);
  //     JOBPrintPDF(object);
  //   }
  //   handleDownloadCSV(object) {
  //     JobGenerateCSV(object);
  //   }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  getCollectionName() {
    return "committee";
  }

  addNotices() {
    this.navigateTo(`/form/${this.getCollectionName()}/`);
  }

  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute("committee", data.id);
    this.refetchData();
  }

  submitMe() {
    upsertUseCase().execute(this.getCollectionName(), this.state);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      case "Array":
        where[field] = { $regex: value, $options: "i" };
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.filterSubmit(where);
  }

  onChangeOption(field, value) {
    this.setState({ [field]: value });
    if (field === "position") {
      this.onChangeFilter("Pointer", value, "positionTitle");
    } else if (field === "status") {
      this.onChangeFilter("String", value, "status");
    }
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    console.log("LFFFFFFFFF: ", objects);
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    const excludeField = [
      "positionTitle",
      "dateClosed",
      "createdAt",
      "submissionDeadline",
      "committeeName",
      "status",
    ];
    const includeField = Object.keys(schema.fields).filter(
      (key) => !excludeField.includes(key)
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Committee Structures {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                {/* <Search
                  // schemas={this.getSchemas()}
                  // onSubmit={(value) => this.onChangeOption(value)}
                  // fields={schema.fields}
                  schemas={schema}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                /> */}

                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.addNotices.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.collection}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                refetch={this.refetchData.bind(this)}
                progress={loading}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, includeField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(CommitteeListPage);
